import React from "react";

const formatAmount = (amount) => {
  const formatted = parseFloat(amount).toFixed(2);
  return formatted.replace(/\.?0+$/, '');
};

function convertAmount(value, currency, shouldConvert) {
  if (!shouldConvert) {
    return value;
  }

  if (currency === "EUR") {
    return value / 1.95583;
  }

  if (currency === "BGN") {
    return value * 1.95583;
  }

  throw new Error("Should not get here!")
}

const Money = ({ amount, currency, convert = false }) => {
  const currencySymbol = currency.toUpperCase() === 'EUR' ? '€' : 'лв.';

  const value = convertAmount(amount, currency, convert)

  return (
    <span className="money">
      <span className="amount">{formatAmount(value)}</span>
      <span className="currency"> {currencySymbol}</span>
    </span>
  );
};

export default Money;
